<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('form_label_store_fabric_information') || '店铺面料信息'"
      direction="rtl"
      :size="899"
      @close="$refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :resFabricInfoCode="resFabricInfoCode"
          :resFabricScmCode="resFabricScmCode"
          @close="close()"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    resFabricInfoCode: { type: String, default: '' },
    resFabricScmCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
